import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';

const NotFoundPage: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl p-6 border border-gray-100">
      <h1 className="text-2xl font-bold text-slate-700 mb-2">Page not found</h1>
      <p className="text-slate-600 mb-6">The page you’re looking for doesn’t exist.</p>
      <Link to="/dashboard">
        <Button variant="primary">Back to Dashboard</Button>
      </Link>
    </div>
  );
};

export default NotFoundPage;

